<template>

  <div class="main shadow">

    <div class="custom-wrapper ">


      <div class="price-input-container">
        <div class="price-input">
          <div class="price-field">
            <span class="text-dark" v-t="`filter.price.min_input`"></span>
            <input type="number"
                   class="min-input"
                   v-model="selectedPrice.min">
          </div>
          <div class="price-field">
            <span class="text-dark" v-t="`filter.price.max_input`"></span>
            <input type="number"
                   class="max-input"
                   v-model="selectedPrice.max">
          </div>
        </div>
        <div class="slider-container">
          <div class="price-slider">
          </div>
        </div>
      </div>

      <!-- Slider -->
      <div class="range-input">
        <input type="range"
               class="min-range"
               min="0"
               :max="price.max"
               v-model="selectedPrice.min"
               step="1">
        <input type="range"
               class="max-range"
               min="0"
               :max="price.max"
               v-model="selectedPrice.max"
               step="1">
      </div>
    </div>

    <div class="text-center">
      <div class="btn btn-primary px-3 my-2 rounded-pill " @click="emitPriceToParent"
           v-t="`filter.price.submit_button`"></div>
    </div>

  </div>

</template>

<script>
import {defineComponent} from 'vue'


export default defineComponent({
  name: "FilterPrice",
  data() {
    return {
      price: {
        min: 0,
        max: 1_000_000_000
      },
      selectedPrice: {
        min: 0,
        max: 1_000_000_000
      }
    }
  },
  methods: {
    emitPriceToParent() {
      let min = document.querySelector('.min-input').value
      let max = document.querySelector('.max-input').value

      this.$emit('price', {minValue: min, maxValue: max})
    },
    async setRange() {
      let req = await this.$store.dispatch('Product/getArchiveFiltersRangePrice')
      let baseData=  req.data.data
      this.selectedPrice.min = baseData.min_price
      this.selectedPrice.max = baseData.max_price
      this.price.min = baseData.min_price
      this.price.max = baseData.max_price
    }
  },
  mounted() {
    this.setRange()
  },
  watch: {
    selectedPrice: {
      handler: async function (newValue, oldValue) {
        if (newValue != null) {


          let minvalue = this.selectedPrice.min
          let maxvalue = this.selectedPrice.max

          if (minvalue >= maxvalue) { // consider bigger value in min section.
            this.selectedPrice.min = maxvalue - 1
          }

          if (maxvalue > this.price.max) { // consider bigger value in max section.
            this.selectedPrice.max = this.price.max
          }


          let priceSlider = document.querySelector(".slider-container .price-slider");

          priceSlider.style.right = `${(this.selectedPrice.min / this.price.max) * 100}%`;
          priceSlider.style.left = `${100 - ((this.selectedPrice.max / this.price.max) * 100)}%`;

        }
      },
      deep: true
    },
  }

})
</script>

<style scoped>

.main {
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  width: 100%;
}

.gfg {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
  color: var(--primary);
}

.custom-wrapper {
  margin: 0;
  width: 100%;
  position: relative;
}

.header h2 {
  font-size: 30px;
  color: var(--primary);
  display: flex;
  justify-content: center;
  padding: 20px;
}

/* Styles for the price input container */
.price-input-container {
  width: 100%;
}

.price-input .price-field {
  display: flex;
  margin-bottom: 22px;
}

.price-field span {
  margin-left: 10px;
  margin-top: 6px;
  font-size: 17px;
}

.price-field input {
  flex: 1;
  height: 35px;
  font-size: 15px;
  font-family: "DM Sans", sans-serif;
  border-radius: 9px;
  text-align: center;
  border: 0px;
  background: #e4e4e4;
}

.price-input {
  width: 100%;
  font-size: 19px;
  color: var(--secondary);
}

/* Remove Arrows/Spinners */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.slider-container {
  width: 100%;
}

.slider-container {
  height: 6px;
  position: relative;
  background: #e4e4e4;
  border-radius: 5px;
}

.slider-container .price-slider {
  height: 100%;
  right: 0%;
  left: 0%;
  position: absolute;
  border-radius: 5px;
  background: var(--primary);
}

.range-input {
  position: relative;
}

.range-input input {
  position: absolute;
  width: 100%;
  height: 5px;
  background: none;
  top: -5px;
  pointer-events: none;
  cursor: pointer;
  -webkit-appearance: none;
}

/* Styles for the range thumb in WebKit browsers */
input[type="range"]::-webkit-slider-thumb {
  height: 18px;
  width: 18px;
  border-radius: 70%;
  background: var(--secondary);
  pointer-events: auto;
  -webkit-appearance: none;
}

@media screen and (max-width: 768px) {
  .custom-wrapper {
    width: 100%;
    left: 0;
    padding: 0 10px;
  }

  .projtitle {
    width: 100%;
    position: relative;
    right: 26px;
  }

  .price-input {
    flex-direction: column;
    align-items: center;
  }

  .price-field {
    margin-bottom: 10px;
  }
}


</style>